var _defs, _polygon, _path, _rect, _circle, _polygon2, _path2, _path3, _path4, _line, _line2, _polyline, _line3, _line4, _line5, _line6, _polyline2, _line7, _line8, _polygon3, _path5, _rect2, _circle2, _polygon4, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudComputingFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0099f5;}.cls-2{fill:#ececec;}.cls-3{fill:#e2e2e2;}.cls-4,.cls-5,.cls-6{fill:none;stroke:#f0457d;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.cls-5{stroke-dasharray:10.02 25.05;}.cls-6{stroke-dasharray:11.36 28.39;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud Computing Network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.25 221.54 82.55 221.54 82.55 216.8 97.51 216.8 97.51 164.87 102.25 164.87 102.25 221.54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.82,213.82a5.35,5.35,0,1,0,5.35,5.35A5.35,5.35,0,0,0,82.82,213.82Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.08,
    y: 157.08,
    width: 4.74,
    height: 49.22
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 141.45,
    cy: 206.03,
    r: 5.35
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.35 221.54 180.65 221.54 180.65 164.87 185.4 164.87 185.4 216.8 200.35 216.8 200.35 221.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.09,224.52a5.35,5.35,0,1,0-5.35-5.35A5.36,5.36,0,0,0,200.09,224.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.28,130.33a35.76,35.76,0,0,0,.5-5.71,35.4,35.4,0,0,0-35.4-35.4c-.19,0-.36,0-.55,0A53.76,53.76,0,0,0,77.51,114.34c0,1.16.1,2.3.17,3.44a35.39,35.39,0,0,0,12.07,68.66H198.19a30.36,30.36,0,0,0,16.09-56.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.8,130.33a35.76,35.76,0,0,0,.5-5.71,35.4,35.4,0,0,0-35.41-35.4c-.18,0-.36,0-.54,0A53.75,53.75,0,0,0,130.8,60.56a54.53,54.53,0,0,0-5.6.29c15.76,1.89,29.17,12.91,36.26,28.4.15,0,.31,0,.47,0,16.9,0,30.6,15.85,30.6,35.4a39.64,39.64,0,0,1-.44,5.71c7.41,5.37,12.35,14.87,12.35,25.73,0,16.78-11.75,30.38-26.26,30.38H197.7a30.36,30.36,0,0,0,16.1-56.11Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 336.58,
    y1: 123.23,
    x2: 342.58,
    y2: 123.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 367.62,
    y1: 123.23,
    x2: 390.17,
    y2: 123.23
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "402.69 123.23 408.69 123.23 408.69 129.23"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 408.69,
    y1: 157.62,
    x2: 408.69,
    y2: 183.18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.69,
    y1: 197.37,
    x2: 408.69,
    y2: 203.37
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 164.33,
    y1: 379.11,
    x2: 158.33,
    y2: 379.11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 133.28,
    y1: 379.11,
    x2: 110.74,
    y2: 379.11
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "98.22 379.11 92.22 379.11 92.22 373.11"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 92.22,
    y1: 344.72,
    x2: 92.22,
    y2: 319.16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.22,
    y1: 304.97,
    x2: 92.22,
    y2: 298.97
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.35 436.46 300.64 436.46 300.64 431.71 315.6 431.71 315.6 379.78 320.35 379.78 320.35 436.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.91,428.74a5.35,5.35,0,1,0,5.35,5.35A5.35,5.35,0,0,0,300.91,428.74Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 357.17,
    y: 372,
    width: 4.74,
    height: 49.22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 359.55,
    cy: 420.95,
    r: 5.35
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "418.45 436.46 398.75 436.46 398.75 379.78 403.49 379.78 403.49 431.71 418.45 431.71 418.45 436.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.18,439.44a5.35,5.35,0,1,0-5.35-5.35A5.36,5.36,0,0,0,418.18,439.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.37,345.25a34.64,34.64,0,0,0,.5-5.71,35.4,35.4,0,0,0-35.4-35.4l-.54,0a53.77,53.77,0,0,0-101.33,25.1c0,1.16.1,2.3.17,3.44a35.39,35.39,0,0,0,12.07,68.66H416.28a30.35,30.35,0,0,0,16.09-56.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.89,345.25a35.76,35.76,0,0,0,.5-5.71A35.4,35.4,0,0,0,397,304.14l-.54,0a53.74,53.74,0,0,0-47.55-28.68,54.53,54.53,0,0,0-5.6.29c15.76,1.89,29.18,12.9,36.26,28.39l.47,0c16.9,0,30.6,15.85,30.6,35.4a41.13,41.13,0,0,1-.43,5.71c7.4,5.37,12.34,14.87,12.34,25.73,0,16.78-11.75,30.38-26.25,30.38H415.8a30.36,30.36,0,0,0,16.09-56.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputingFlat);
export default __webpack_public_path__ + "static/media/cloud-computing-flat.882f19e387396110936735f350c69203.svg";
export { ForwardRef as ReactComponent };